import { Model } from "@vuex-orm/core";
import config from "../configs/Meeting";
import Building from "./Building";
import Mandate from "./Mandate";
import Resolution from "./Resolution";
import Media from "./Media";
import MeetingResolution from "./MeetingResolution";

export default class Meeting extends Model {
  static get entity() {
    return "meetings";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      licence_id: this.attr(null),
      building_id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      meeting_date: this.attr(null),
      address: this.attr(null),
      address_description: this.attr(null),
      access: this.attr(null),
      minutes: this.attr([]),
      freezed_meeting_details: this.attr([]),
      status: this.attr(null),
      resolutions_count: this.attr(null),
      has_resolutions_without_keys: this.attr(null),
      current_resolution_id: this.attr(null),
      timer: this.attr(null),
      external_video_solution: this.attr(null),
      show_connection_details: this.attr(null),
      votes_need_recalculations: this.attr(null),
      // NOTE: Here we will have a json with enabled meeting types: physic, correspondence, videoconference
      allowed_modalities: this.attr(null),
      // NOTE: This date will be the last date when the agency can set the votes for the bo
      last_reception_date: this.attr(null),

      presence_media: this.belongsTo(Media, "presence_media_id"),
      presence_media_id: this.attr(null),
      zip_media: this.belongsTo(Media, "zip_media_id"),
      zip_media_id: this.attr(null),
      agenda_media: this.belongsTo(Media, "agenda_media_id"),
      agenda_media_id: this.attr(null),
      minutes_media: this.belongsTo(Media, "minutes_media_id"),
      minutes_media_id: this.attr(null),
      signed_pv_media: this.belongsTo(Media, "signed_pv_media_id"),
      signed_pv_media_id: this.attr(null),
      signed_presence_media: this.hasOne(Media, "signed_presence_meeting_id"),
      mandates: this.hasMany(Mandate, "meeting_id"),

      additional_print_media: this.hasMany(Media, "meeting_id"),
      additional_invitation_print_media: this.hasMany(
        Media,
        "additional_invitation_media_meeting_id"
      ),
      archived_doc_details: this.belongsTo(Media, "archived_doc_details_media_id"),
      archived_doc_details_media_id: this.attr(null),

      meeting_room_name: this.attr(null),
      // ???: ??
      // resolutions: this.belongsToMany(Resolution, MeetingResolution, "meeting_id", "resolution_id"),
      // HACK: .. needed for list table .. sort by number of resolutions
      meeting_resolutions: this.hasMany(MeetingResolution, "meeting_id"),
      // HACK: to order by building name
      building: this.belongsTo(Building, "building_id"),
      isMediaMissing: this.attr(null),
      // to generate pdfs
      is_scheduled_to_generate_pdfs: this.attr(null),
      generate_pdfs_progress: this.attr(null),
      is_scheduled_to_generate_pv_antet_pdfs: this.attr(null),
      generate_pv_antet_pdfs_progress: this.attr(null),
      invitation_docs_order: this.attr(null),
      mercure_jwt_token: this.attr(null),
      doc_requests: this.attr(null),
      doc_status: this.attr(null),
      invitation: this.attr(null),

      docs_print_color: this.attr(null),
      voting_categories: this.attr(null),
      send_invitation_files_to_asl_co_owners: this.attr(null),
      send_pv_files_to_asl_co_owners: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
